/**
 * HTML escaping for AI-generated summaries.
 *
 * summary_text is produced by an LLM fed with remote article content, so it is
 * untrusted: a poisoned RSS entry can make the model emit raw tags. Every
 * summary rendered through dangerouslySetInnerHTML must be escaped first, then
 * have only the markup we generate ourselves (CVE links, bold, line breaks)
 * re-introduced on top. Mirrors the Telegram guard in common/core.py.
 */
export function escapeHtml(text) {
    if (!text) return "";
    return String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
